<div class="container">
  <div class="row">
    <div class="col-lg-5 col-md-12 col-sm-12">
      <div class="card border-secondary mb-3" style="width: 100%;">
        <div class="card-header">
          <b>Patient Details</b>
        </div>
        <div class="card-body">
          <ul class="list-group list-group-flush text-secondary">
            <li class="list-group-item">Number <span class="float-end">{{patient?.patient_number}}</span>
          </li>
          <li class="list-group-item">Name <span class="float-end">{{patient?.first_name}}
          {{patient?.last_name}}</span></li>
          <li class="list-group-item">Email <span class="float-end">{{patient?.email}}</span>
        </li>
        <li class="list-group-item">Phone <span class="float-end">{{patient?.phone}}</span>
      </li>
      <li class="list-group-item">Secandary Phone <span class="float-end">{{patient?.phone2}}</span>
    </li>
    <li class="list-group-item">Gender <span class="float-end">{{patient?.gender |
    uppercase}}</span>
  </li>
  <li class="list-group-item">Date of Birth <span class="float-end">{{patient?.birth_date |
  date}}</span>
</li>
<li class="list-group-item">Address <span class="float-end">{{patient?.address}}</span>
</li>
<li class="list-group-item">Occupation <span
class="float-end">{{patient?.visiting_reason}}</span>
</li>
</ul>
</div>
<div class="card-footer text-muted">
  <button type="button" class="btn btn-outline-info" (click)="open(contentFiles)">Add files</button>
  <a [routerLink]="['/invoices']" [queryParams]="{id: patient?.id}"
  class="btn btn-outline-primary ms-1">Get Invoices</a>
  <a [routerLink]="['/appointments']" [queryParams]="{patient: patient?.id}"
  class="btn btn-outline-dark ms-1">Check Appointments</a>
</div>
</div>
<!-- <div class="card border-secondary mb-3" style="width: 100%;">
<div class="card-header">
  <b>Invoices</b>
</div>
<div class="card-body">
  <table class="table table-bordered" id="excel-table">
    <thead>
      <tr class="table-secondary">
        <th>#</th>
        <th>id</th>
        <th>date</th>
        <th>Amount</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngIf="invoices.length == 0">
        <td colspan="4">No Data Found.</td>
      </tr>
      <tr
        *ngFor="let item of invoices | slice: (page_c-1) * pageSize_c : (page_c-1) * pageSize_c + pageSize_c; let i = index;">
        <td>{{i+1}}</td>
        <td>{{item.a}}</td>
        <td>{{item.date | date: 'dd MMMM yyyy'}}</td>
        <td>{{item.amount}}</td>
      </tr>
    </tbody>
  </table>
  <ngb-pagination [collectionSize]="invoices.length" [(page)]="page_c" [maxSize]="5" [rotate]="true"
  [ellipses]="false" [boundaryLinks]="false"></ngb-pagination>
</div>
</div> -->
</div>
<div class="col-lg-7 col-md-12 col-sm-12">
  <div class="card border-secondary mb-3" style="width: 100%;">
    <div class="card-header">
      <b>Patient Files</b>
    </div>
    <div class="card-body">
      <table class="table table-bordered" id="excel-table">
        <thead>
          <tr class="table-secondary">
            <th>#</th>
            <th>File</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @if (patient?.files?.length == 0) {
            <tr>
              <td colspan="2">No Data Found.</td>
            </tr>
          }
          @for (f of patient?.files ?? []; track f; let i = $index) {
            <tr>
              <td>{{i+1}}</td>
              <td>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-file-earmark-text" viewBox="0 0 16 16">
                  <path
                    d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5" />
                  <path
                    d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z" />
                </svg>
                <a [href]="f.file.file" target="_blank" rel="noopener noreferrer" class="file-link">
                  {{ getFileName(f.file.file) }}
                </a>
              </td>
              <td>
                <button [disabled]="!utility.isAllowed(['admin', 'accountant', 'doctor'])"
                  type="button" class="btn btn-danger" (click)="onDelete(f.id)">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                    fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                    <path
                      d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                    <path fill-rule="evenodd"
                      d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                  </svg>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
      <ngb-pagination [collectionSize]="packages.length" [(page)]="page_d" [maxSize]="5" [rotate]="true"
      [ellipses]="false" [boundaryLinks]="false"></ngb-pagination>
    </div>
  </div>
</div>
<div class="col-lg-7 col-md-12 col-sm-12">
  <div class="card border-secondary mb-3" style="width: 100%;">
    <div class="card-header">
      <b>Packages Subscriptions</b>
    </div>
    <div class="card-body">
      <table class="table table-bordered" id="excel-table">
        <thead>
          <tr class="table-secondary">
            <th>#</th>
            <th>Service</th>
            <th>Sessions</th>
            <th>Left</th>
            <th>Taken</th>
            <th>Price</th>
            <th>Paied</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          @if (packages.length == 0) {
            <tr>
              <td colspan="4">No Data Found.</td>
            </tr>
          }
          @for (item of packages | slice: (page_d-1) * pageSize_d : (page_d-1) * pageSize_d + pageSize_d; track item; let i = $index) {
            <tr
              >
              <td>{{i+1}}</td>
              <td>{{item.service_name}}</td>
              <td>{{item.no_sessions}}</td>
              <td>{{item.no_sessions_left}}</td>
              <td>{{item.no_sessions_took}}</td>
              <td>{{item.full_price}}</td>
              <td>{{item.paied_amount}}</td>
              <td>{{item.created_at | date: 'dd MMMM yyyy'}}</td>
            </tr>
          }
        </tbody>
      </table>
      <ngb-pagination [collectionSize]="packages.length" [(page)]="page_d" [maxSize]="5" [rotate]="true"
      [ellipses]="false" [boundaryLinks]="false"></ngb-pagination>
    </div>
  </div>
  <!-- <div class="card border-secondary mb-3" style="width: 100%;">
  <div class="card-header">
    <b>Comming Appointments</b>
    <span class="float-end"><button type="button" class="btn btn-outline-light"
    (click)="open(contentAppointment)">Create Appointment</button></span>
  </div>
  <div class="card-body">
    <table class="table table-bordered" id="excel-table">
      <thead>
        <tr class="table-secondary">
          <th>#</th>
          <th>Service</th>
          <th>Date</th>
          <th>Time</th>
          <th>Clinician</th>
          <th>Status</th>
          <!-- <th>Created on</th> --
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="appointments.length == 0">
          <td colspan="7">No Data Found.</td>
        </tr>
        <tr
          *ngFor="let item of appointments | slice: (page_a-1) * pageSize_a : (page_a-1) * pageSize_a + pageSize_a; let i = index;">
          <td>{{i+1}}</td>
          <td style="white-space: nowrap; width: 1%;">
            <span class="svg-icon svg-icon-primary svg-icon-2x" style="cursor: pointer;"
              (click)="goToDetails(item)">
              {{item.appointment.service}}
            </span>
          </td>
          <td>{{item.appointment.date | date: 'dd MMMM yyyy'}}</td>
          <td>{{item.appointment.date | date: 'hh:mm a'}}</td>
          <td>{{item.doctor.name}}</td>
          <td>{{item.appointment.status}}</td>
          <!-- <td>{{item.appointment.created_at | date: 'dd MMMM yyyy'}}</td> --
        </tr>
      </tbody>
    </table>
    <ngb-pagination [collectionSize]="appointments.length" [(page)]="page_a" [maxSize]="5"
    [rotate]="true" [ellipses]="false" [boundaryLinks]="false"></ngb-pagination>
  </div>
</div>
<div class="card border-secondary mb-3" style="width: 100%;">
  <div class="card-header">
    <b>History</b>
  </div>
  <div class="card-body">
    <table class="table table-bordered" id="excel-table">
      <thead>
        <tr class="table-secondary">
          <th>#</th>
          <th>Service</th>
          <th>Date</th>
          <th>Time</th>
          <th>Clinician</th>
          <th>status</th>
          <!-- <th>Created on</th> --
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="history.length == 0">
          <td colspan="7">No Data Found.</td>
        </tr>
        <tr
          *ngFor="let item of history | slice: (page_b-1) * pageSize_b : (page_b-1) * pageSize_b + pageSize_b; let i = index;">
          <td>{{i+1}}</td>
          <td style="white-space: nowrap; width: 1%;">
            <span class="svg-icon svg-icon-primary svg-icon-2x" style="cursor: pointer;"
              (click)="goToDetails(item)">
              {{item.appointment.service}}
            </span>
          </td>
          <td>{{item.appointment.date | date: 'dd MMMM yyyy'}}</td>
          <td>{{item.appointment.date | date: 'hh:mm a'}}</td>
          <td>{{item.doctor.name}}</td>
          <td>
            <span *ngIf="item.appointment.status=='CONFIRMED'"
            class="badge bg-success">{{item.appointment.status}}</span>
            <span *ngIf="item.appointment.status=='MISSED'"
            class="badge bg-primary">{{item.appointment.status}}</span>
            <span *ngIf="item.appointment.status=='PENDING'"
            class="badge bg-dark">{{item.appointment.status}}</span>
            <span *ngIf="item.appointment.status=='COMPLETED'"
            class="badge bg-success">{{item.appointment.status}}</span>
            <span *ngIf="item.appointment.status=='CANCELLED'"
            class="badge bg-warning">{{item.appointment.status}}</span>
            <span *ngIf="!item.appointment.payment_id" class="badge bg-warning ms-1">not
            paid</span>
            <span *ngIf="item.appointment.payment_id" class="badge bg-primary ms-1">paid</span>
          </td>
          <!-- <td>{{item.appointment.created_at | date: 'dd MMMM yyyy'}}</td> --
        </tr>
      </tbody>
    </table>
    <ngb-pagination [collectionSize]="history.length" [(page)]="page_b" [maxSize]="5" [rotate]="true"
    [ellipses]="false" [boundaryLinks]="false"></ngb-pagination>
  </div>
</div> -->
</div>
</div>
</div>

<ng-template #contentAppointment let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">New Appointment</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <div class="row">
        <div class="col">
          <label for="doctor_id" class="form-label">Clinician</label>
          <select class="form-select" [(ngModel)]="appointment.doctor_id" (change)="getDoctorSlots()">
            <option [ngValue]="null">-- SELECT --</option>
            @for (doctor of doctors; track doctor) {
              <option [ngValue]='doctor.id'>{{ doctor.name }}
              </option>
            }
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="date" class="form-label">Date</label>
          <input type="datetime-local" class="form-control" id="date" [(ngModel)]="appointment.date"
            [disabled]="appointment.doctor_id==null">
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label class="form-label">Clinician Booked Slots</label>
          <div class="card">
            <div class="card-body table-wrapper">
              <table class="table">
                <tr>
                  <td>date</td>
                  <td colspan="2">time</td>
                </tr>
                @for (slot of dateSelection(slots); track slot) {
                  <tr>
                    <td>{{slot.date_time | date:'dd/MM/yyyy'}}</td>
                    <td>{{slot.date_time | date:'hh:mm a'}}</td>
                    <td>{{slot.date_time_to | date:'hh:mm a'}}</td>
                  </tr>
                }
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="service" class="form-label">Type of Service</label>
          <select class="form-select" [(ngModel)]="appointment.service" (change)="getPrice()"
            [disabled]="appointment.patient_id==null">
            <option [ngValue]="null">-- SELECT SERVICE --</option>
            @for (service of services; track service) {
              <option [ngValue]='service.id'>{{ service.name }}
              </option>
            }
          </select>
        </div>
        <div class="col">
          <label for="price" class="form-label">Price</label>
          <input type="number" class="form-control" [(ngModel)]="appointment.price" id="price" disabled>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="period" class="form-label">Appointment Period</label>
          <div class="form-check">
            <input class="form-check-input" type="radio" name="period" id="period30"
              [(ngModel)]="appointment.period" [value]="30">
            <label class="form-check-label" for="period30">
              30 minutes
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" name="period" id="period60"
              [(ngModel)]="appointment.period" [value]="60">
            <label class="form-check-label" for="period60">
              60 minutes
            </label>
          </div>
        </div>
        <div class="col">
          <label for="period" class="form-label">- -</label>
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" id="walkin" [(ngModel)]="appointment.walkin">
            <label class="form-check-label" for="walkin">Walk-in</label>
          </div>
          <div class="form-check form-switch">
            <input class="form-check-input" type="checkbox" id="overbooked"
              [(ngModel)]="appointment.overbooked">
            <label class="form-check-label" for="overbooked">Over booked</label>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <label for="notes" class="form-label">Notes</label>
        <textarea class="form-control" [(ngModel)]="appointment.notes" id="notes" rows="2" cols="50"></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="createAppointment(contentPackage)"
    [disabled]="appointment.service==''">Add</button>
  </div>
</ng-template>
<ng-template #contentFiles let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Upload Patient Files</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <div class="mb-3">
        <label for="patinet_files" class="form-label">Contract Copy</label>
        <input type="text" class="form-control" [(ngModel)]="files" id="patinet_files" hidden>
        <input type="file" class="form-control" id="file" (change)="fileChange($event)">
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="submit()">Submit</button>
  </div>
</ng-template>
<ng-template #contentPackage let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Select Package</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <div class="row">
        <div class="col">
          <p><b>Please Select Package type for payment if the payment is based on Installment, otherwise
          select No Package.</b></p>
        </div>
      </div>
    </div>
    <div class="mb-3">
      <div class="row">
        <div class="col">
          <label for="gender" class="form-label">Package Type</label>
          <select class="form-select" [(ngModel)]="package.package_id" (change)="onChangePackage()">
            <option [ngValue]="null">-- No Package --</option>
            @for (package of packages_all; track package) {
              <option [ngValue]='package.id'>{{ package.name }}
              </option>
            }
          </select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for="price" class="form-label">Number of Sessions</label>
        <input type="text" class="form-control" [(ngModel)]="package.no_sessions" id="price" disabled>
      </div>
      <div class="col">
        <label for="price" class="form-label">Price per Session</label>
        <input type="text" class="form-control" [(ngModel)]="package.session_price" id="price" disabled>
      </div>
      <div class="col">
        <label for="price" class="form-label">Total</label>
        <input type="text" class="form-control" [ngModel]="package.no_sessions * +package.session_price"
          id="price" disabled>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="OnSumbitPackage()">Confirm</button>
  </div>
</ng-template>